function _asyncToGenerator(t) {
    return function() {
        var e = t.apply(this, arguments);
        return new Promise(function(t, i) {
            return function o(a, n) {
                try {
                    var r = e[a](n),
                        s = r.value
                } catch (t) {
                    return void i(t)
                }
                if (!r.done) return Promise.resolve(s).then(function(t) {
                    o("next", t)
                }, function(t) {
                    o("throw", t)
                });
                t(s)
            }("next")
        })
    }
}

function _toConsumableArray(t) {
    if (Array.isArray(t)) {
        for (var e = 0, i = Array(t.length); e < t.length; e++) i[e] = t[e];
        return i
    }
    return Array.from(t)
}! function(t, e) {
    "use strict";
    var i = {};
    t.init = function() {
        i.question = e(".question-answer-block .question"), i.answer = e(".question-answer-block .answer"), i.question.on("click", function() {
            e(this).siblings(".answer").slideToggle()
        })
    }
}(window.Accordion = window.Accordion || {}, jQuery),
function(t, e) {
    "use strict";
    var i = {},
        o = void 0,
        a = function() {
            o = e(window).outerHeight()
        },
        n = function() {
            e(window).scrollTop() > o ? r() : s()
        },
        r = function() {
            i.toTop.addClass("active")
        },
        s = function() {
            i.toTop.removeClass("active")
        };
    t.init = function() {
        i.toTop = e("[data-to-top]"), i.toTop.on("click", function() {
            e("html, body").animate({
                scrollTop: 0
            })
        }), e(window).on("resize", a), e(document).on("scroll", n), a(), n()
    }, t.show = r, t.hide = s
}(window.BackToTop = window.BackToTop || {}, jQuery),
function(t, e) {
    "use strict";
    var i = {},
        o = function(t) {
            e.get("/cart?view=contents", function(t) {
                i.cartContentsEntryPoint.html(t)
            }).done(function() {
                e(".money").addClass("animate-up"), setTimeout(function() {
                    e(".money").removeClass("animate-Up")
                }, 300)
            })
        };
    t.addToCart = function(t, e, i) {
        CartJS.addItem(e, i, {}, {
            success: function(t, e, i) {
                o()
            }
        })
    }, t.updateItem = function(t, e, i) {
        CartJS.updateItemById(e, i, {}, {
            success: function(t, e, i) {
                o()
            }
        })
    }, t.removeItem = function(t, e) {
        CartJS.removeItemById(e, {
            success: function(t) {
                console.log(t)
            }
        })
    };
    var a = function() {
        e("body").on("click", "[data-add-upsell]", function() {
            var i, o;
            console.log("clicked upsell"), i = e(this), o = i.data("variant-id"), i.toggleClass("active"), i.hasClass("active") ? t.addToCart(i, o, 1) : t.updateItem(i, o, 0)
        }), e("body").on("click", ".cart-page__qty-btn", function() {
            var i, o, a, n, r, s;
            console.log(e(this)), i = e(this), o = e(this).parents(".cart-page__item-wrap"), n = i.data("variant-id"), r = parseInt(i.data("price")), s = void 0, a = (.01 * (r *= s = i.hasClass("cart-page__qty-btn--add") ? parseInt(i.siblings("input").val()) + 1 : parseInt(i.siblings("input").val()) - 1)).toFixed(2), o.find(".cart-page__total-price .money").html("$" + a), i.siblings("input").val(s), t.updateItem(i, n, s),
                function(t, e) {
                    0 === e && t.parents(".cart-page__item-wrap").fadeOut("fast")
                }(i, s)
        }), e("body").on("click", "[data-cart-checkout]", function() {
          console.log("clicked checkout");
            $('#addedToCartModal').toggle();
          if(window.location.href.indexOf('cart') != -1){
          $("body").append("<div class='modal-backdrop in'></div>");$("body").addClass("modal-open")
          }
          $('.loading-modal').css('display','block');
          console.log("clicked check");
          location.href = "/checkout";
          sessionStorage.clear();
        })
    };
    t.init = function() {
        i.cartContentsEntryPoint = e("[data-cart-entry-point]"), i.lineItemQtyBtn = e(".cart-page__qty-btn"), i.lineItemAdd = e("[data-line-item-add]"), i.lineItemMinus = e("[data-line-item-minus]"), i.body = e("body"), a(), o()
    }
}(window.Cart = window.Cart || {}, jQuery),
function(t, e) {
    var i = {},
        o = Cookies.get("email-capture"),
        a = function() {
            i.emailCapture.removeClass("email-capture--active")
        },
        n = function() {
            i.emailCapture.addClass("email-capture--active"), setTimeout(function() {
                r()
            }, 2e3)
        },
        r = function() {
            var t = "Email address".split(""),
                e = t.length,
                o = "",
                a = 0;
            i.emailFormInput.focus(), setInterval(function() {
                if (!(a < e)) return !1;
                o += t[a], i.emailFormInput.attr("placeholder", o), a++
            }, 75), i.inputClicked = !0
        },
        s = function() {
            i.closeIcon.on("click", function() {
                sessionStorage.setItem("capture-closed", "true"), i.emailCapture.removeClass("email-capture--active")
            }), i.emailCaptureForm.on("submit", function(t) {
                e(this);
                var i = e(".email-capture-form__input").val();
                Helpers.checkEmail(i) ? (e(".success_message").css("display", "block"), Cookies.set("email-capture", "true", {
                    expires: 432e3
                }), ga("send", "event", "email", "new popup", "submission")) : e(".error_message").css("display", "block")
            })
        };
    t.init = function() {
        i.emailCapture = e(".email-capture"), i.closeIcon = e(".js-close-capture"), i.emailCaptureForm = e(".email-capture-form"), i.emailFormInput = e(".email-capture-form__input"), i.inputClicked = !1, "true" === sessionStorage.getItem("capture-closed") ? a() : "true" === o ? a() : void 0 === o && setTimeout(function() {
            n()
        }, 4e3), s()
    }
}(window.EmailCapture = window.EmailCapture || {}, jQuery),
function(t, e) {
    "use strict";
    t.checkEmail = function(t) {
        return /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(t)
    }, t.debounce = function(t, e, i) {
        var o = void 0;
        return function() {
            var a = this,
                n = arguments,
                r = i && !o;
            clearTimeout(o), o = setTimeout(function() {
                o = null, i || t.apply(a, n)
            }, e), r && t.apply(a, n)
        }
    }
}(window.Helpers = window.Helpers || {}, jQuery),
function(t, e) {
    "use strict";
    var i = {};
    t.update = function(t) {
        e.get("/cart?view=contents", function(t) {
            i.inlineCart.html(t)
        })
    }, t.show = function() {
        i.inlineCart.addClass("is-active")
    }, t.hide = function() {
        i.inlineCart.removeClass("is-active")
    };
    t.init = function() {
        i.inlineCart = e("[data-inline-cart]"), i.lineItemEntryPoint = e("[data-cart-contents]")
    }
}(window.InlineCart = window.InlineCart || {}, jQuery),
function(t, e) {
    t.init = function() {
        new t
    }
}(window.LazyLoad = window.LazyLoad || {}, jQuery),
function(t, e) {
    "use strict";
    var i = {};
    t.show = function(t) {
        return window.Overlay.show(), i.body.attr("data-active-modal", t), e('[data-modal="' + t + '"]').fadeIn(300)
    }, t.hide = function() {
        return window.Overlay.hide(), i.body.removeAttr("data-active-modal"), i.modal.fadeOut(300)
    };
    t.init = function() {
        i.body = e("body"), i.modal = e("[data-modal]"), i.modalShow = e("[data-modal-show]"), i.modalHide = e("[data-modal-hide]"), i.modalShow.on("click", function(t) {
            t.preventDefault(), window.Modal.show(e(this).attr("data-modal-show"))
        }), i.modalHide.on("click", function(t) {
            t.preventDefault(), window.Modal.hide()
        })
    }
}(window.Modal = window.Modal || {}, jQuery),
function(t, e) {
    "use strict";
    var i = {};
    t.show = function() {
        return i.overlay.fadeIn(300)
    }, t.hide = function() {
        return i.overlay.fadeOut(300)
    }, t.toggle = function() {
        return i.overlay.fadeToggle(300)
    };
    t.init = function() {
        i.overlay = e("[data-overlay]"), i.overlay.on("click", window.Overlay.hide)
    }
}(window.Overlay = window.Overlay || {}, jQuery),
function(t, e) {
    "use strict";
    var i = {},
        o = function() {
            i.engraveBtn.on("click", function(t) {
                i.engravePolicy.css("display", "block"), i.engraveModalClass.addClass("in"), Overlay.hide()
            }), i.engraveClose.on("click", function(t) {
                i.engravePolicy.css("display", "none"), i.engraveModalClass.removeClass("in"), Overlay.hide()
            })
        };
    t.init = function() {
        i.engraveBtn = e("#customizebtn"), i.engravePolicy = e("#engravePolicyModal"), i.engraveModalClass = e(".engravePolicyModal"), i.engraveClose = e(".js-engrave-close"), o()
    }
}(window.Product = window.Product || {}, jQuery),
function(t, e) {
    "use strict";
    t.lock = function(t) {
        e("html, body").addClass("no-scroll")
    }, t.unlock = function(t) {
        e("html, body").removeClass("no-scroll")
    }, t.toggle = function(t) {
        e("html, body").toggleClass("no-scroll")
    };
    t.init = function() {}
}(window.Scroll = window.Scroll || {}, jQuery),
function(t, e, i) {
    var o = {
            centerMode: !0,
            arrows: !1,
            variableWidth: !0,
            adaptiveHeight: !0,
            slidesToScroll: 1,
            slidesToShow: 1,
            mobileFirst: !0,
            responsive: [{
                breakpoint: 1023,
                settings: {
                    centerMode: !1,
                    arrows: !0,
                    variableWidth: !1,
                    slidesToShow: 3
                }
            }]
        },
        a = function(t) {
            t.wrap("<div class='prod-block__slick-wrap' />")
        };
    t.init = function() {
        e(".coll-carousel__prods").on("init setPosition", function(t) {
            var i = e(".slick-list", e(this));
            i.css("height", "unset");
            var o = i.outerHeight();
            i.css("height", o)
        }), e(".coll-carousel__prods").length && (a(e(".prod-block")), e(".coll-carousel__prods").slick(o))
    }
}(window.Sliders = window.Sliders || {}, jQuery),
function(t, e) {
    "use strict";
    var i = {},
        o = void 0,
        a = !0,
        n = !0,
        r = function(t) {
          if($(window).width() < 768){
            i.toggles.parent().not(t).removeClass("visible"), t.toggleClass("visible")
          }
        },
        s = function(t) {
            var i = e(window).outerHeight() - t.offset().top + e(window).scrollTop();
            t.outerHeight(i)
        },
        c = function() {
            o <= e(window).scrollTop() ? i.wrap.addClass("s") : i.wrap.removeClass("s")
        },
        l = function() {
            o = i.header.outerHeight()
        },
        d = function(t, e, i) {
            CollectionMix.mixer[t].setFilterGroupSelectors(e, i), CollectionMix.mixer[t].parseFilterGroups()
        },
        u = function(t, e) {
            CollectionMix.mixer[t].sort(e)
        },
        p = function(t) {
            t.toggleClass("active");
            var o = t.parent(),
                n = t.closest(".filter__option"),
                r = [],
                s = "";
            e(".active", o).each(function(t) {
                r.push(e(this).attr("data-filters")), s = 0 == t ? e(this).text() : s + ", " + e(this).text()
            });
            a ? (a = !1, e(".coll-section__more").fadeOut(), i.colls.each(function() {
                var t = this;
                e(".coll-section__more-btn:visible", e(this).parent()).length ? CollectionMix.moreProds(e(this), void 0, function(i) {
                    ! function(t, e, i, o) {
                        CollectionMix.mixer[t].append(o), CollectionMix.mixer[t].setFilterGroupSelectors(e, i), CollectionMix.mixer[t].parseFilterGroups()
                    }(e(t).attr("data-loop"), o.attr("data-filter-group"), r, i)
                }) : d(e(this).attr("data-loop"), o.attr("data-filter-group"), r)
            })) : i.colls.each(function() {
                d(e(this).attr("data-loop"), o.attr("data-filter-group"), r)
            }), e(".active[data-filters]", n).length ? e(".filter__option-clear", n).fadeIn() : e(".filter__option-clear", n).fadeOut(), e(".filter__list-name", n).text(s)
        },
        f = function(t) {
            var o = t.attr("data-sorts"),
                a = t.closest(".sort");
            e(".sort__title", a).text(t.text()), r(e(void 0).closest(".sort")), n ? (n = !1, e(".coll-section__more").fadeOut(), i.colls.each(function() {
                var t = this;
                e(".coll-section__more-btn:visible", e(this).parent()).length ? CollectionMix.moreProds(e(this), void 0, function(i) {
                    ! function(t, e, i) {
                        CollectionMix.mixer[t].append(i), CollectionMix.mixer[t].sort(e)
                    }(e(t).attr("data-loop"), o, i)
                }) : u(e(this).attr("data-loop"), o)
            })) : i.colls.each(function() {
                u(e(this).attr("data-loop"), o)
            })
        };
    t.init = function() {
        i.nav = e(".site-navigation"), i.header = e(".coll-header"), i.collWrap = e(".collection-wrapper"), i.colls = e("[data-loop]"), i.wrap = e(".sort-filter__wrap"), i.toggles = e("[data-sf-toggle]"), i.filterTitles = e(".filter__option-name"), i.filters = e("[data-filters]"), i.sorts = e("[data-sorts]"), i.clear = e(".sort-filter__clear"), i.filterClear = e(".filter__option-clear"), i.toggles.on("click", function() {
            r(e(this).parent()), s(e(this).next())
        }), i.filterTitles.on("click", function() {
          if($(window).width() < 990){
            e(this).parent().toggleClass("open"), e(this).next().slideToggle()
          }
        }), i.filters.on("click", function(t) {
          t.stopPropagation();
            p(e(this)), e("[data-sf-toggle]").trigger('click')
        }), i.sorts.on("click", function() {
            f(e(this))
        }), i.clear.on("click", function() {
            i.colls.each(function() {
                var t = e(this).attr("data-loop");
                e("[data-filter-group]").each(function() {
                    CollectionMix.mixer[t].setFilterGroupSelectors(e(this).attr("data-filter-group"), "")
                }), CollectionMix.mixer[t].parseFilterGroups()
            }), e(this).hide(), i.filterClear.fadeOut(), i.filters.removeClass("active"), e(".filter__list-name").text("")
        }), i.filterClear.on("click", function(t) {
            t.stopPropagation();
            var o = e(this).closest(".filter__option");
            i.colls.each(function() {
                d(e(this).attr("data-loop"), o.find("[data-filter-group]").attr("data-filter-group"), "")
            }), e(this).fadeOut(), e(".active[data-filters]", o).removeClass("active"), e(".filter__list-name", o).text("")
        }), e(window).on("scroll", function() {
            c(), e(".sort-filter__wrap:not(.stuck) .visible").length && s(e(".visible [data-sf-wrap]"))
        }), e(window).on("resize", function() {
            l()
        }), l(), c()
    }, t.mixStart = function(t) {
        var o = e(t.container).parent();
        i.filters.addClass("disabled"), e(".coll-section__overlay", o).addClass("overlayed")
    }, t.mixEnd = function(t) {
        var o = e(t.container).parent(),
            a = parseInt(e(".coll-section__count-max", o).text());
        e.getScript("//productreviews.shopifycdn.com/assets/v4/spr.js?shop=slidebelts.myshopify.com"), 0 == t.totalShow ? o.fadeOut() : o.fadeIn(), e(".prod-block", o).css("align-self", "auto"), e(t.show[0]).css("align-self", "auto"), e(".coll-section__count-current", o).text(t.totalShow), t.totalShow >= a ? e(".coll-section__more", o).fadeOut() : e(".coll-section__more-btn", o).text("+ Load More"), e(".active[data-filters]").length ? e(".sort-filter__clear").fadeIn() : e(".sort-filter__clear").fadeOut(), e(".prod-block:visible").length ? e(".sort-filter__no-prods").fadeOut() : e(".sort-filter__no-prods").fadeIn(), i.filters.removeClass("disabled"), e(".coll-section__overlay", o).removeClass("overlayed")
    }
}(window.SortFilter = window.SortFilter || {}, jQuery),
function(t, e) {
    "use strict";
    var i = function(t, e) {
            o(t, e), a(t, e), n(t, e), r(t, e), s(t, e)
        },
        o = function(t, i) {
            var o = t.attr("data-src");
            e(".prod-block__image", i).animate({
                opacity: 0
            }, 0, function() {
                e(this).siblings().attr("srcset", o), e(this).attr("src", o), e(this).one("load", function() {
                    e(this).animate({
                        opacity: 1
                    }, 0)
                })
            })
        },
        a = function(t, i) {
            var o = t.attr("data-url");
            e("a", i).attr("href", o)
        },
        n = function(t, i) {
            var o = t.attr("data-price"),
                a = t.attr("data-compare-price"),
                n = t.attr("data-raw-price");
            e(".prod-block__price", i).html(o), e(".prod-block__price-compare", i).html(a), i.attr("data-price", n)
        },
        r = function(t, i) {
            var o = t.attr("data-stock");
            e(".prod-block__stock", i).html(o)
        },
        s = function(t, i) {
            e("[data-swatch]", i).removeClass("selected"), t.addClass("selected")
        };
    t.init = function() {
        e(".product-loop").on("mouseover", '[data-swatch="prod-block"]', function() {
            var t = e(this).closest("[data-slick-handle]").attr("data-slick-handle"),
                o = e(this).attr("data-variant");
            if (console.log("what is slick", t), console.log("are we in !slick", !t), t) {
                var a = e(this).closest(".slick-track");
                console.log("blocks", e('[data-slick-handle="' + t + '"]', a)), e('[data-slick-handle="' + t + '"]', a).each(function() {
                    i(e('[data-variant="' + o + '"]', this), e(this))
                })
            } else i(e(this), e(this).closest(".prod-block"))
        })
    }
}(window.Swatches = window.Swatches || {}, jQuery),
function(t, e) {
    "use strict";
    var i, o = {},
        a = {},
        n = function(t) {
            var i,ptype, o = "string" == typeof t.badge ? '<div class="prod-block__badge">' + t.badge + "</div>" : "",
                a = t.varSize > 5 ? '<span class="prod-block__extra-swatches">+' + (t.varSize - 5) + "</span>" : "",
                n = t.options.map(function(t) {
                    return t.values
                }),
                r = (i = []).concat.apply(i, _toConsumableArray(n)).map(function(t) {
                    return "_" + t.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "")
                }).join(" "),
                s = t.tags.map(function(t) {
                    return "_" + t.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "")
                }).join(" "),
                ptype =  "_" + t.type.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "").split("-").shift(),
                c = t.tags.join().includes("date::") ? t.tags.find(function(t) {
                    return t.includes("date::")
                }).replace("date::", "") : t.date;
            console.log("date:", c);
            var l = "",
                d = "",
                u = void 0,
                p = "",
                f = void 0,
                v = t.imagev245,
                m = t.imagev155,
                h = "swatch-buckle-"; - 1 != t.tags.indexOf("Belt Strap") ? -1 != t.tags.indexOf('Skinny (7/8")') ? h = "swatch-skinny-" : -1 != t.tags.indexOf("Vegan Leather") || -1 != t.tags.indexOf("Genuine Leather") ? h = "swatch-" : -1 != t.tags.indexOf("Top Grain Leather") || -1 != t.tags.indexOf("Wallet") ? h = "swatch-tg-" : -1 != t.tags.indexOf("Full Grain Leather") ? h = "swatch-fg-" : -1 == t.tags.indexOf("Canvas") && -1 == t.tags.indexOf("Vegan Canvas") || (h = "swatch-canvas-") : -1 != t.title.indexOf("Survival") ? h = "swatch-survival-" : -1 != t.type.indexOf("Wallet") && (h = "swatch-tg-");
            var g = void 0,
                w = void 0,
                _ = void 0,
                b = void 0,
                k = "",
                C = void 0,count = 0,firstAvlVar = t.firstVar, cur_image = t.image245, cur_invPolicy = t.invPolicy, cur_invQty = t.invQty, bufferQty = 10,
                  y = void 0 ;
          if((t.tags.indexOf("no_inventory_buffer") == -1) || (t.tags.indexOf("discontinued") == -1)){
          bufferQty = 0;
          }
           for(var ini = 0; ini < t.variants.length; ini++){
                  
                  if(t.variants[ini].invQty > bufferQty){
                  firstAvlVar = t.variants[ini].id;
                    cur_image = t.variants[ini].dataSrc;
                    cur_invPolicy = t.variants[ini].invPolicy;
                    cur_invQty = t.variants[ini].invQty;
                    break;
                  }
                }
          
          if(( t.tags.indexOf("no_inventory_buffer") != -1 ||  t.tags.indexOf("discontinued") != -1) && cur_invQty <= 0){ l = "SOLD OUT" }
else if( t.tags.indexOf("no_inventory_buffer") == -1 &&  t.tags.indexOf("discontinued") == -1 && t.type != "Gift Card" && cur_invQty <= 10){l = "OUT OF STOCK"}
else if( t.type == "Gift Card" ){l =""}
          t.varSize > 1 && t.variants.forEach(function(e) { count = count +1;
           (count < 4)? (u = e.id == firstAvlVar ? " selected" : "", f = e.title.split("/"), console.log(f), g = f[0].trim().split(" ").join("-").toLowerCase().replace("square-", "").replace('$', "").replace("-italian-leather", "").concat(".png"), console.log("varImgsrc:", g), w = "https://cdn.shopify.com/s/files/1/0082/8872/files/".concat(h).concat(g), console.log("prefixed:", w), _ = e.altImage.includes("no-image") ? w : e.altImage, p = "", b = "", -1 == t.tags.indexOf("no_inventory_buffer") ? t.available ? "deny" == e.invPolicy && e.invQty <= 10 && (p = "OUT OF STOCK") : p = "SOLD OUT" : t.available ? "deny" == e.invPolicy && e.invQty <= 0 && (p = "OUT OF STOCK") : p = "SOLD OUT","Gift Card" == t.type && (p =""), "Gift Card" == t.type && (b = "width:35px;height:35px"), d += '<div style="' + b + '" class="prod-block__swatch' + u + '" data-swatch="prod-block" data-src="' + e.dataSrc + '" data-url="' + e.url + '" data-raw-price="' + e.priceRaw + '" data-price="' + e.price + '" data-compare-price="' + e.priceCompare + '" data-stock="' + p + '">\n          <img class="prod-block__swatch-img ok2" src="' + _ + '" alt="' + e.title + '">\n        </div>'
            ):""}), "" != t.priceCompare && (k = "prod-block__price-yes-compare"), t.ratingStar <= 2 && (y = "display:none"), -1 != t.type.indexOf("Watch") && (C = "display:none"), t.varSize > 1 && (v = cur_image, m = cur_image);
            var x = '<div class="prod-block prod-block--' + t.handle + " " + s + " " + ptype + " " + '" data-price="' + t.priceRaw + '" data-date="' + c + '">\n      ' + o + '\n      <a href="' + t.url + '" class="prod-block__picture-link">\n        <picture class="prod-block__picture">\n          <source\n            media="(min-width:768px)"\n            srcset="' + v + '">\n          <source\n            srcset="' + m + '">\n\n          <img class="prod-block__image" src="' + cur_image + '">\n        </picture>\n      </a>\n      <div class="prod-block__info">\n           <h4 class="prod-block__title"><a href="' + t.url + '" class="prod-block__title-link">' + t.title + '</a></h4>\n        <div class="prod-block__price-cont">\n          <span class="prod-block__price ' + k + '">' + t.price + '</span>\n          <span class="prod-block__price-compare">' + t.priceCompare + '</span>\n          <span class="prod-block__stock">' + l + '&nbsp;</span>\n        </div>\n        <div class="prod-block__swatches" style="' + C + '">\n        ' + d + "\n        " + a + '\n        </div>\n        <a href="' + t.url + '" class="prod-block__view-button">View Product</a>\n      </div>\n  </div>\n  </div>';
            return e("<div />").html(x).children()[0]
        },
        r = function(t) {
            return fetch("/collections/" + t + "?view=ajax").then(function(t) {
                return t.status >= 200 && t.status < 300 ? Promise.resolve(t) : Promise.reject(new Error(t.statusText))
            }).then(function(t) {
                return t.json()
            }).then(function(t) {
                return console.log("Request succeeded with JSON response", t), t
            }).catch(function(t) {
                console.log("Request failed", t)
            })
        },
        s = (i = _asyncToGenerator(regeneratorRuntime.mark(function t(e, i, o) {
            var a, s, c, l, d, u;
            return regeneratorRuntime.wrap(function(t) {
                for (;;) switch (t.prev = t.next) {
                    case 0:
                        return e.attr("data-loop"), a = e.attr("data-handle"), parseInt(e.attr("data-limit")), s = parseInt(e.attr("data-page")), c =  (parseInt(e.attr("data-limit"))), t.next = 7, r(a);
                    case 7:
                        l = t.sent, d = l.slice(c, i), u = [], d.forEach(function(t) {
                            u.push(n(t))
                        }), o(u);
                    case 12:
                    case "end":
                        return t.stop()
                }
            }, t, void 0)
        })), function(t, e, o) {
            return i.apply(this, arguments)
        });
    t.init = function() {
        a.colls = e("[data-loop]"), a.loadMore = e("[data-load-more]"), a.loadMore.on("click", function() {
            var t = e(this).closest(".coll-section"),
                i = e("[data-loop]", t),
                a = i.attr("data-loop"),
                n = parseInt(i.attr("data-page")) + 1;
            s(i, (25 * n ), function(t) {
                o[a].append(t)
            }), i.attr("data-page", n), e(".coll-section__more-btn", t).text("Loading")
        }), a.colls.each(_asyncToGenerator(regeneratorRuntime.mark(function t() {
            var i, a;
            return regeneratorRuntime.wrap(function(t) {
                for (;;) switch (t.prev = t.next) {
                    case 0:
                        i = e(this).attr("data-loop"), e(this).attr("data-limit"), a = '[data-loop="' + i + '"]', o[i] = mixitup(a, {
                            selectors: {
                                target: ".prod-block",
                              control: '[data-filters]'
                            },
                            multifilter: {
                                enable: !0,
                                minSearchLength: 5
                            },
                            callbacks: {
                                onMixEnd: function(t) {
                                    SortFilter.mixEnd(t)
                                },
                                onMixStart: function(t) {
                                    SortFilter.mixStart(t)
                                }
                            }
                        });
                    case 4:
                    case "end":
                        return t.stop()
                }
            }, t, this)
        })))
    }, t.mixer = o, t.moreProds = s
}(window.CollectionMix = window.CollectionMix || {}, jQuery),
function(t, e) {
    var i = {};
    t.init = function() {
        i.navItemDropdown = e(".nav-item--has-nested-nav"), i.footerDropdown = e(".footer-nav__item--has-dropdown"), i.footerNewsletter = e(".footer-email-form"), e(".footer-nav-item__title").on("click", function(t) {
            t.preventDefault(), window.innerWidth <= 768 && e(this).siblings().toggleClass("is-active")
        }), i.footerNewsletter.on("submit", function(t) {
            var i = e(".footer-email-form__input").val();
            Helpers.checkEmail(i) ? e(".success_message").css("display", "block") : e(".error_message").css("display", "block")
        })
    }
}(window.FooterNavigation = window.FooterNavigation || {}, jQuery),
function(t, e) {
    var i = {},
        o = function() {
            e(".nav-mobile-content").each(function() {
                e(".mnav").removeClass("is-active")
            })
        },
        a = function() {
            i.mobileNavToggle.on("click", function() {
                

                const $btnMenu = document.querySelector('.js-mobile-nav-toggle')
                const $btnClose = document.querySelector('.js-mobile-nav-close')
                const $navMobileContent = document.querySelector('.nav-mobile-content')

                $btnMenu.classList.add('hidden')
                $btnClose.classList.add('is-active')
                $navMobileContent.classList.add('is-active')

                const $navSticky = document.querySelector('#shopify-section-navigation')
                const $topbar = document.querySelector('.site-navigation')

                const $body = document.querySelector('body')
                $body.classList.add('no-scroll')

                if( $navSticky && $topbar ) {
                  const { top } = $navSticky.getBoundingClientRect()
                  $navSticky.style.position = 'fixed'

                  $navSticky.style.top = `${top}px`
                  $navMobileContent.style.top = `${top + 50}px`
                  $navMobileContent.style.height = `calc(100vh - ${top}px)`
                }

            }), i.mobileClose.on("click", function() {
                

                  const $btnMenu = document.querySelector('.js-mobile-nav-toggle')
                  const $btnClose = document.querySelector('.js-mobile-nav-close')
                  const $navMobileContent = document.querySelector('.nav-mobile-content')

                  $btnMenu.classList.remove('hidden')
                  $btnClose.classList.remove('is-active')
                  $navMobileContent.classList.remove('is-active')

                  const $navSticky = document.querySelector('#shopify-section-navigation')
                  const $topbar = document.querySelector('.site-navigation')
                  const $body = document.querySelector('body')

                  $body.classList.remove('no-scroll')

                  if( $navSticky && $topbar ) {
                    $navSticky.style.position = 'sticky'
                    $navSticky.style.top = '0px'
                  }

            }), i.mobileBackBtn.on("click", function(t) {
                t.stopPropagation(), e(this).closest(".submenu-top").parent().removeClass("is-active")
            }), i.mobileParentItem.on("click", function(t) {
              var curr = {};var curr_arrow ={};
                console.log("mobile parent item clicked"), curr = e(this).next(".mobile-submenu").toggleClass("is-active"), curr_arrow = e(this).find(".mobile-arrow").toggleClass("is-active"),e(".mobile-submenu").not(curr).removeClass("is-active"),e(".mobile-arrow").not(curr_arrow).removeClass("is-active")
            }), e(".has-grand-menu").on("click", function() {
                e(this).children(".mobile-grand-menu").addClass("is-active")
            }), i.globalMobileNavLink.on("click", function(t) {
                e(".js-mobile-nav-toggle").removeClass("hidden"), o()
            }), i.grandDropdown.on("click", function() {
                var t = e(this);
                t.siblings().hasClass("is-active") && t.children().hasClass("is-active") ? (t.siblings(".is-active").removeClass("is-active"), t.children(".is-active").removeClass("is-active")) : (t.closest(".test-grand-container").find(".great-grand-menu.is-active").removeClass("is-active"), t.closest(".test-grand-container").find(".grand-menu-arrow.is-active").removeClass("is-active"), t.siblings().addClass("is-active"), t.children(".grand-menu-arrow").addClass("is-active"))
            }), i.subMenuLink.hover(function(t) {
                var i = e(this).attr("js-nav-child-link");
                e(".mega-nav").find(".mega-nav__submenu-item.is-active").removeClass("is-active"), e(this).addClass("is-active"), e('.has-right-content[js-nav-child-link="' + i + '"]').addClass("is-active"), e(".mega-nav").find(".mega-nav-right__content.is-active").removeClass("is-active"), e('.mega-nav-right__content[js-content="' + i + '"]').addClass("is-active")
            }), i.parentHasSubnav.hover(function() {
                
            })
              
        };
    t.init = function() {
        i.childLink = e("[js-nav-child-link]"), i.parentHasSubnav = e(".nav-item--has-sub-nav"), i.mobileNavToggle = e(".js-mobile-nav-toggle"), i.mobileParentWrap = e(".nav-mobile-content"), i.mobileParentItem = e("[js-mobile-parent-item]"), i.submenuBackBtn = e(".submenu-back-btn"), i.mobileBackBtn = e(".mobile-back-btn"), i.mobileClose = e(".js-mobile-nav-close"), i.grandDropdown = e(".js-grand-dropdown"), i.globalMobileNavLink = e(".mnav-link"), i.subMenuLink = e(".has-right-content"), a()
    }
}(window.Navigation = window.Navigation || {}, jQuery),
function(t, e) {
    "use strict";
    e(window), e("body");
    var i = {};
    t.hide = function() {
      e(".findify-layouts--autocomplete--fullscreen__container").css("display","none");
        i.seachForm.removeClass("is-visible")
    };
    var o = function() {
        i.closeSearchForm.on("click", function() {
            i.seachForm.removeClass("is-visible")
        }), i.toggleSearch.on("click", function(t) {
            t.stopPropagation(), i.seachForm.toggleClass("is-visible"), setTimeout(function() {
                e('input[name="q"]').focus()
            }, 500)
        })
    };
    t.init = function() {
        i.toggleSearch = e("[toggle-search]"), i.seachForm = e(".form-search"), i.closeSearchForm = e("[close-search]"), o()
    }
}(window.Search = window.Search || {}, jQuery);

$('.prod-block').on('mouseover', function(){
  if($(this).find('img.coll-section__feature-img').length !== 0){
  $(this).css('border','none');
  }
});



/* Desktop Navigation*/
$(document).ready(function() {

  var temp_flag = localStorage.getItem('template_flag');
  
  
   $('.nav-item__link').on('click',function(){
     localStorage.setItem('selected-link',$(this).text());
	navDrop($(this));
  });

    $('.mobile-parent--has-submenu').on('click',function(){
  localStorage.setItem('m-selected-link',$(this).find('.mobile-parent__link').attr('id'));                     
  });
  
  $('.mobile-submenu-list__item').on('click',function(){
     $(this).find('.mobile-submenu-list__item-link').css('color','#c46049');
            $(this).find('.bcompany,.breward,.chelp,.bloc,.bhiw,.chiw,.dhiw,.ehiw,.bhelp,.dhelp,.c-our-story,.btag,.ctag,.bshop,.cshop,#coworking-icon').css('stroke','#c46049');
            $(this).find('.ecompany,.fhelp,.eloc,.bhelp,.c-our-story,.btag,.ctag,#coworking-icon').css('fill','#c46049');
  });
  
  /*
  $('.mega-nav__submenu-item').on('click',function(){
     localStorage.setItem('selected-sublink',$(this).find('.mega-nav__submenu-link').text());
  });
  */
   (function() {
  var filterBys = document.querySelectorAll('[data-blog-tag-filter]');

  if (!filterBys.length) return;

  filterBys.forEach(function(filterBy) {
    filterBy.addEventListener('change', function(evt) {
      location.href = evt.target.value;
    });
  });
})();
  
  function navDrop(e){
    $('.nav-item__link').css("border-bottom","none");
    e.css("border-bottom","3px solid #c46049;padding-top:3px;");
    e.parent().siblings().find('.mega-nav-container').removeClass('mega-nav-visible');
    e.parent().find('.mega-nav-container').toggleClass('mega-nav-visible');
    e.toggleClass('nav-item-hover');
    var is_meganav_visible = 'false';
    $('.mega-nav-container').each(function() {
      if ($(this).hasClass('mega-nav-visible')) {
        is_meganav_visible = 'true';
        return false;
      }
    });
    if(is_meganav_visible =='false'){
      $('.navigation--spacing-helper').css('height','0px');
    }
    else if(is_meganav_visible =='true'&& ($(window).width() >= 991)){
      
      $('.navigation--spacing-helper').css('height','121px');

    }
  }

  //filters
  if($(window).width() >= 991){

      function toggleCollection($elem){
        $('[data-sf-toggle]').parent().not($elem).removeClass('visible');
        $elem.toggleClass('visible');
        //$('[data-sf-wrap]').toggleClass('overflowVisible');

      }
      function setHeightCollection($elem){
        
        const elemHeight = $(window).outerHeight() - 50 + $(window).scrollTop();
        $elem.outerHeight(elemHeight);
       
      }

      $('.filter__option-name').parent().toggleClass('open');
      $('.filter__option-name').next().slideToggle();

      toggleCollection($('.filter__title').parent());
      setHeightCollection($('.filter__title').next());
    }

 
  
   $('.sort__item,.sort__title-wrap').on('click',function(){
  $('.sort__wrap').toggleClass('overflowVisible');
      $('.filter__wrap').removeClass('overflowVisible');

  });
$('.filter__item,.filter__title').on('click',function(){

  $('.sort__wrap').removeClass('overflowVisible') ;
$('.sort').removeClass('visible') ;
  });


  //fix for findify suggestion sticking to screen
  $(".nav-item-search").on("click",function(){

    if ($('.navigation--spacing-helper').height() != 0 ){
      $('.form-search').css('top','194px');
    }
    else{
      $('.form-search').css('top','70px');
    }
  });
  
  var selctedMenu="";
    var selctedSubMenu="";
   var selctedMobSubMenu="";
  var url_path = window.location.pathname;
  console.log("URL",url_path.split("/").pop());
  
  if($(window).width() >=990){
    if(localStorage.getItem('selected-link')){selctedMenu = "#"+localStorage.getItem('selected-link').toLowerCase().split(" ").join("-");}
  selctedSubMenu = "#"+url_path.split("/").pop();

  }
  else{
 selctedMobSubMenu = "#m"+url_path.split("/").pop();

  }
   if($(window).width() <=990 && window.location.pathname != '/'){
      if(localStorage.getItem('m-selected-link')){
      var test = "#"+localStorage.getItem('m-selected-link').toLowerCase();
        console.log("test:",test);
        $(test).next('.mobile-arrow').toggleClass('is-active');
         $(test).parent().next('.mobile-submenu').toggleClass('is-active');
      }
    }
  
   
  if(temp_flag == 'collection' ||  temp_flag== 'product.SurvivalPDP'){
  navDrop($('#shop'));   
  }
  if(selctedSubMenu || selctedMobSubMenu){
    if($(window).width() >=990){
      $('.mega-nav__submenu-link').each(function(){
        if(selctedSubMenu.indexOf($(this).attr("id").replace("#","")) !=-1){
         $(this).css('color','#2C2C2C');
          $(this).css('font-family','gibson-semibold');
          $(this).siblings().find('.bcompany,.breward,.chelp,.bloc,.bhiw,.chiw,.dhiw,.ehiw,.bhelp,.dhelp,.c-our-story,.btag,.ctag,.bshop,.cshop,#coworking-icon').css('stroke','#2C2C2C');
          $(this).siblings().find('.ecompany,.fhelp,.eloc,.bhelp,.c-our-story,.btag,.ctag,#coworking-icon,.jobs-icon').css('fill','#2C2C2C');
        }
      });
        
      }else{
        $('.mobile-submenu-list__item-link').each(function(){
          if(selctedMobSubMenu.indexOf($(this).attr("id").replace("#m","")) !=-1){
            $(this).css('color','#2C2C2C');
            $(this).css('font-family','gibson-semibold');
            $(this).siblings().find('.bcompany,.breward,.chelp,.bloc,.bhiw,.chiw,.dhiw,.ehiw,.bhelp,.dhelp,.c-our-story,.btag,.ctag,.bshop,.cshop,#coworking-icon').css('stroke','#2C2C2C');
            $(this).siblings().find('.ecompany,.fhelp,.eloc,.bhelp,.c-our-story,.btag,.ctag,#coworking-icon,.jobs-icon').css('fill','#2C2C2C');
          }
        });
      }
  }
  
  
  function sa(s){
  $('[data-filters="._'+s+'"]').trigger('click');
  }
  if(temp_flag == 'collection' || window.location.href.indexOf('#filter=') != -1){
 var hashedfilters = window.location.href.split("#filter=").pop();
  console.log(hashedfilters);
   var hashedValue = hashedfilters.split(',');
      console.log("hashedValue:",hashedValue);
   
    //  Make sure the filter dropdown selects the hash item
    
  
    if (hashedValue == 'premium'){
    
      
       setTimeout(function(){
         
          $('[data-filters="._full-grain-leather"]').trigger('click');
        }, 000);
       setTimeout(function(){
         
          $('[data-filters="._top-grain-leather"]').trigger('click');
        }, 1500);
    }else{
   hashedValue.forEach(function(obj,index) {
        setTimeout(function(){
         
           sa(obj);
        }, index * 000);
   });}
    /*for(var i in hashedValue){
    sa(hashedValue[i]);
    }*/
   
  }
function scrollToAnchor(aid){
    var aTag = $("div[id='"+ aid +"']");
  setTimeout( function() {$('html,body').animate({scrollTop: aTag.offset().top}, 500)}, 0);
}

$(".review-stars").click(function() {
   scrollToAnchor('productReviews');
});

  var details_link = false;
  if(details_link){
    $(".top_bar_text p:last-child").append('&nbsp;<span id="topHeaderBtn">Details</span>');
  } 
  
      if($(window).width() <=990){
$( ".holidaybar-text" ).remove();
}

// Get the modal
var modal = document.getElementById("topHeaderModal");

// Get the button that opens the modal
var btn = document.getElementById("topHeaderBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks on the button, open the modal
$("#topHeaderBtn").on('click touchstart', function () { 

  modal.style.display = "block";
  var elem = document.createElement('div');
elem.className = 'modal-backdrop in';  $("body").addClass("modal-open");
        document.body.appendChild(elem);
  var fpt = "Discount off select products as marked. Custom engraving excluded. Discount is not applied to taxes and shipping fees. Price as marked for sale. Cannot be combined with other offers and discounts. May not be applied to previous orders.";
  $('.topmodal-header').html('<h4>DETAILS:</h4>');
  $(".fine-print").html(fpt);
  
});
// When the user clicks on <span> (x), close the modal
$("#topHeaderModal .close").on('click touchstart', function() {
  modal.style.display = "none";
  $( ".modal-backdrop.in" ).remove();$("body").removeClass("modal-open")
});

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
      $( ".modal-backdrop.in" ).remove();$("body").removeClass("modal-open")
  }
}

//shop-hire-sub-head text change
$('.subheading_text').html("SlideBelts is a dream team of problem-solvers<br> that are passionate about our craft and scrappy with our resources.");

$('.footer-access').on('click',function(){
$('#INDmenu-btn').trigger('click');
});

$('.lifestyle-imagery-slider').slick({
  arrows: true,
  dots:false,
  infinite: true,
  prevArrow:'<button type="button" class="slick-prev">&#8249;</button>',
  nextArrow:'<button type="button" class="slick-next">&#8250;</button>',
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
  // Page reload when browser back button is hit
  window.addEventListener( "pageshow", function ( event ) {
  var historyTraversal = event.persisted || 
                         ( typeof window.performance != "undefined" && 
                              window.performance.navigation.type === 2 );
  if ( historyTraversal ) {
    // Handle page restore.
    // window.location.reload();
  }
});   

  });
 $( document ).ready(function() {
      params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'attributes[TBYB]=',
            dataType: 'json'
          };
      $.ajax(params);
      }, this);

